import UserRole from '../type/enum/UserRole';
import { Action, permissions, Resource } from '../permissions/rolePerimissionsUtil';
import { useSecurityContext } from './useSecurityContext';

const usePermission = () => {
    const { user } = useSecurityContext();

    const userIsAuthenticated = (): boolean => {

        return user?.authStatus === 'AUTHENTICATED';
    };

    const hasPermission = (resource: Resource, action: Action): boolean => {
        const userRole = user?.user?.role || UserRole.ROLE_CLIENT;
        const rolePermissions = permissions[userRole];

        return (
            rolePermissions &&
            rolePermissions[resource] &&
            rolePermissions[resource].includes(action)
        );
    };

    return { userIsAuthenticated, hasPermission };
};

export default usePermission;
